import { render, staticRenderFns } from "./SaleInfo.vue?vue&type=template&id=7ec2a01c&scoped=true"
import script from "./SaleInfo.vue?vue&type=script&lang=ts"
export * from "./SaleInfo.vue?vue&type=script&lang=ts"
import style0 from "./SaleInfo.vue?vue&type=style&index=0&id=7ec2a01c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec2a01c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ec2a01c')) {
      api.createRecord('7ec2a01c', component.options)
    } else {
      api.reload('7ec2a01c', component.options)
    }
    module.hot.accept("./SaleInfo.vue?vue&type=template&id=7ec2a01c&scoped=true", function () {
      api.rerender('7ec2a01c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/SaleInfo.vue"
export default component.exports